import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Preferences } from '@capacitor/preferences'; // opcional si prefieres Capacitor
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface LoginResponse {
  status: boolean;
  TOKEN?: string;
  mensaje?: string;
  // ...otros campos del backend
}

const TOKEN_KEY = 'tokenAuth';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private _token: string | null = null;

  constructor(private http: HttpClient) {}

  get token(): string | null {
    return this._token;
  }

  async loadTokenFromStorage(): Promise<string | null> {
    // Si usas Ionic Storage, reemplaza por this.storage.get(TOKEN_KEY)
    const { value } = await Preferences.get({ key: TOKEN_KEY });
    this._token = value || null;
    return this._token;
  }

  async setToken(token: string) {
    this._token = token;
    await Preferences.set({ key: TOKEN_KEY, value: token });
  }

  async clearToken() {
    this._token = null;
    await Preferences.remove({ key: TOKEN_KEY });
  }

  login(body: any): Observable<LoginResponse> {
    return this.http
      .post<LoginResponse>(`${environment.apiBase}/ws_eventos2.php`, body, {
        context: environment.httpCtx.SKIP_AUTH(), // para que el interceptor no agregue Bearer
      })
      .pipe(
        map((res) => res) // aquí puedes transformar si hace falta
      );
  }

  isAuthenticated(): boolean {
    return !!this._token;
  }
}
